import React, { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
    LuArrowLeft,
    LuBadgeCheck,
    LuCircleAlert,
    LuMailCheck
} from 'react-icons/lu';

function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}

function VerifyEmail() {
    const query = useQuery();
    const { verifyEmail } = useAuth();

    const [token, setToken] = useState(query.get('token') || '');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!query.get('token')) {
            return;
        }

        let mounted = true;

        const runVerification = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await verifyEmail(query.get('token'));
                if (!mounted) {
                    return;
                }
                setSuccess(true);
                setMessage(response.message || 'E-posta adresiniz doğrulandı.');
            } catch (err) {
                if (mounted) {
                    setError(err.message);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        runVerification();

        return () => {
            mounted = false;
        };
    }, [query, verifyEmail]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setMessage('');

        if (!token.trim()) {
            setError('Doğrulama tokenı zorunludur.');
            return;
        }

        setLoading(true);

        try {
            const response = await verifyEmail(token.trim());
            setSuccess(true);
            setMessage(response.message || 'E-posta adresiniz doğrulandı.');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container auth-container-single">
                <div className="auth-form-section">
                    <div className="auth-form-wrapper">
                        <Link to="/login" className="back-link">
                            <LuArrowLeft /> Girişe Dön
                        </Link>

                        <div className="auth-header">
                            <div className="auth-logo">
                                <LuMailCheck />
                            </div>
                            <h1>E-posta Doğrulama</h1>
                            <p>Hesabınızı aktifleştirmek için doğrulama tokenını onaylayın.</p>
                        </div>

                        {success ? (
                            <div className="success-state">
                                <div className="success-icon">
                                    <LuBadgeCheck />
                                </div>
                                <h2>E-posta Doğrulandı</h2>
                                <p>{message}</p>
                                <Link to="/login" className="btn btn-primary btn-block">
                                    Girişe Git
                                </Link>
                            </div>
                        ) : (
                            <>
                                {error && (
                                    <div className="auth-error">
                                        <LuCircleAlert className="error-icon" />
                                        {error}
                                    </div>
                                )}

                                <form onSubmit={handleSubmit} className="auth-form">
                                    <div className="form-group">
                                        <label>Doğrulama Tokenı</label>
                                        <div className="input-with-icon">
                                            <LuMailCheck className="input-icon" />
                                            <input
                                                type="text"
                                                className="form-input has-icon"
                                                value={token}
                                                onChange={(e) => setToken(e.target.value)}
                                                placeholder="E-postadaki token"
                                                required
                                                autoCapitalize="off"
                                                autoCorrect="off"
                                            />
                                        </div>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-block"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-small"></span>
                                                İşleniyor
                                            </>
                                        ) : (
                                            'E-postayı Doğrula'
                                        )}
                                    </button>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerifyEmail;
